import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { ReminderTimesConfigurationModel } from '@/modules/settings/pages/alert-reminders/types';
import { SETTINGS_QUERY_NO_CACHE } from '@/lib/api/constants'

/**
 * Fetches basic company settings.
 */
export function useQueryAlertRemindersConfiguration(companyId: string) {
  return useQuery<ReminderTimesConfigurationModel>({
    queryKey: ['configuration.alertReminders', companyId],
    queryFn: async () => {
      // return mockedAlertReminderData
      const { data } = await axiosInstance.get(`/api/${companyId}/configuration/alertReminders`);
      return data;
    },
    enabled: !!companyId,
    ...SETTINGS_QUERY_NO_CACHE,
  });
}
